/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_WorkInputs */

const en_home_hero_cta_work = /** @type {(inputs: Home_Hero_Cta_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See what we build`)
};

const lv_home_hero_cta_work = /** @type {(inputs: Home_Hero_Cta_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt, ko veidojam`)
};

/**
* | output |
* | --- |
* | "See what we build" |
*
* @param {Home_Hero_Cta_WorkInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_cta_work = /** @type {((inputs?: Home_Hero_Cta_WorkInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_WorkInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_cta_work(inputs)
	return en_home_hero_cta_work(inputs)
});